import axios from 'axios';
import { getSecureLocalItem } from '../utils/secureSessionStorage';

// Use just the base URL without /v1/api since your API uses /api/plans
const baseURL = process.env.REACT_APP_BASE_URL;

console.log("🌐 API Base URL:", baseURL);

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - ADD TOKEN HERE
api.interceptors.request.use(
  async (config) => {
    // Get token from secure storage
    const token = getSecureLocalItem("token");
    
    console.log("🔑 Token from storage:", token ? `${token.substring(0, 50)}...` : "No token found");
    
    if (token) {
      // Add token to headers
      config.headers.Authorization = token;
      console.log("✅ Token added to headers");
    } else {
      console.warn("⚠️ No token found in storage");
    }
    
    console.log("📤 API Request:", config.method.toUpperCase(), config.baseURL + config.url);
    console.log("📋 Authorization header:", config.headers.Authorization ? "Present" : "Missing");
    
    return config;
  },
  error => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  response => {
    console.log("✅ API Response:", response.status, response.config.url);
    return response.data;
  },
  error => {
    console.error("❌ API Error:", error.response?.status, error.response?.config?.url);
    console.error("Error details:", error.response?.data);
    
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      console.error("Token expired or invalid. Please login again.");
    }
    
    return Promise.reject(
      error.response?.data || error.message || 'Unknown API error occurred'
    );
  }
);

export default api;